module.exports = "/* MAIN COLOR PALETTE */\n.report-card {\n  width: 140px;\n  text-align: center; }\n.report-card .title {\n    font-size: 12px; }\n.report-card .value {\n    font-size: 14px;\n    font-weight: bold;\n    color: #B71C1C; }\n.mat-card {\n  margin: 10px 2px 20px 2px;\n  padding: 4px 0px; }\n.mat-card-header, .mat-card-title, .mat-card-content {\n  display: block;\n  padding: 0px;\n  margin: 0px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/pages/extension/planters-report/planters-report.component.scss
// module id = ./src/app/admin/pages/extension/planters-report/planters-report.component.scss
// module chunks = main